import { CHECKOUT_WORKS_PARAM } from '../constants';

type Query = Partial<Record<string, string | string[]>>;

export const withWorksQuery = (link: string, productIds: string[]): string => {
  const [pathname, search = ''] = link.split('?');
  const params = new URLSearchParams(search);

  params.delete(CHECKOUT_WORKS_PARAM);
  if (productIds.length) {
    params.set(CHECKOUT_WORKS_PARAM, productIds.join(','));
  }

  const query = params.toString();

  return query ? `${pathname}?${query}` : pathname;
};

type ParseWorksArgs = {
  mainId: string;
  workIds: string[];
};

export const parseWorksQuery = (
  query: Query,
  { mainId, workIds }: ParseWorksArgs,
): string[] => {
  const value = query[CHECKOUT_WORKS_PARAM];
  const linkedIds = typeof value === 'string' ? value.split(',') : [];
  const selectedIds = [
    ...new Set(linkedIds.filter((id) => workIds.includes(id))),
  ];

  return selectedIds.length ? selectedIds : [mainId];
};
